import type { DisplayAuthKey } from '@dossierhq/react-components';

export const DISPLAY_AUTH_KEYS: DisplayAuthKey[] = [
  { authKey: '', displayName: 'Default' },
  { authKey: 'subject', displayName: 'User private' },
];
